export default "__VITE_ASSET__DillZoyA__"